export const SIGN_IN_CHANGE_FIELD = 'SIGN_IN_CHANGE_FIELD';

export const SIGN_IN = 'SIGN_IN';

export const SIGN_IN_PAGE_DOWN = 'SIGN_IN_PAGE_DOWN';